import { createContext, type ReactNode } from 'react'

import type { Notificacao } from '@/models'

export interface ContextoDeNotificacoesGlobalProps {
  children: ReactNode
}

export interface NotificacoesContextoData {
  notificacoes: Notificacao[]
  carregando: boolean
  carregandoMais: boolean
  erro: boolean
  quantidadeNaoVisualizadas: number
  existemNaoVisualizadas: boolean
  podeCarregarMais: boolean
  popupAberto: boolean

  setPopupAberto: (aberto: boolean) => void
  recarregarNotificacoes: () => Promise<void>
  carregarMaisNotificacoes: () => Promise<void>
  marcarComoLida: (idDaNotificacao: number) => Promise<void>
  marcarTodasComoLidas: () => Promise<void>
  adicionarNotificacao: (notificacao: Notificacao) => void
}

export const NotificacoesContexto = createContext<
  NotificacoesContextoData | undefined
>(undefined)
